<template lang="pug">
  app-modal(
    :closeOutside="false",
    titulo="Cruzamento de camadas",
    :width="1024",
    @closeModal="closeModal()",
  )
    template(slot="body")
      div(v-for="camada in camadas")
        div(v-for="cruzamento in Object.entries(camada)")
          el-row
            el-col(:span="24").border-botton.border-top
              el-col(:span="8")
                div.caixa-flex
                  el-col(:span="24").text-center
                    span Camada
              el-col(:span="16")
                div.caixa-flex
                  el-col(:span="5").border-lefth.text-center
                    span Área
                  el-col(:span="5").border-lefth.text-center
                    span % de interseção
                  el-col(:span="14").border-lefth
                    div
                      span Informações adicionais
            el-col(:span="8")
              div.heigth-100.top-titulo
                el-col(:span="24").text-center
                  span {{cruzamento[0]}}
            el-col(:span="16")
              div(v-for="i in cruzamento[1]").caixa-flex.border-botton
                el-col(:span="5").border-lefth.text-center.flex-center
                  span {{i.area_intersecao.toLocaleString('pt-br', {minimumFractionDigits: 2}) + ' ha'}}
                el-col(:span="5").border-lefth.text-center.flex-center
                  span {{i.pct_intersecao.toLocaleString('pt-br', {minimumFractionDigits: 2})  + ' %'}}
                el-col(:span="14").border-lefth
                  div(v-for="t in Object.entries(i).filter(([e,]) => !removeProp.includes(e)).map(([e, j]) => `${e}: ${j}`)")
                    span {{t}}
    template(slot="footer")
      div.buttons
        el-button(@click="closeModal()") Fechar
</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppModal,
    AppLabel
  },

  props: {
    cruzamento: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      camadas: [],
      removeProp: ['id', 'pct_intersecao', 'area_intersecao']
    }
  },

  mounted () {
    this.camadas = JSON.parse(this.cruzamento).filter(o => Object.keys(o).length)
  },

  methods: {
    closeModal () {
      this.$emit('close')
    }
  }

}
</script>

<style scoped lang="scss">

.caixa-fixa {
  height: 200px;
  overflow: scroll;
}

.caixa-flex {
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
}

.border-botton {
  border-bottom: 1px solid rgb(66, 66, 66);
}

.border-top {
  border-top: 1px solid rgb(66, 66, 66);
}

.text-center {
  text-align: center;
}

.border-lefth {
  border-left: 1px solid rgb(66, 66, 66);
  padding-left: 5px;
  padding-right: 5px;
}

.flex-center {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.heigth-100 {
  display: flex;
  flex-flow: column;
}

.top-titulo {
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppModalCruzamentoCamada.vue